import { FeatureFlags } from "../../../../Forms/Types/FeatureFlags";
import { FullFormAction } from "../../../Core/Store/FullFormAction";

import { FeatureFlagsActionType } from "./FeatureFlagsActions";

export const defaultFeatureFlagsState = {};

export function featureFlagsReducer(state = defaultFeatureFlagsState, action: FullFormAction): FeatureFlags {
    switch (action.type) {
        case FeatureFlagsActionType.LoadInitialFeatureFlags: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
}
